import React from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import "./Header.css"
import { data } from "../../Common/Text/NormalText";

const Header = ({ title }) => {
  return (
    <div>
      <div className="header-container-v">
        <h1 className="header-title-v">{title}</h1>
        <div className="button-section-paymentmethod-v">
          <button className="invite-btn-paymentmethod-v">{data?.refer}</button>
          <div className="ellipse-for-more-paymentmethod-v">
            <MoreHorizIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
